const DetryBillComponent = () => import('@/views/WareHouse/DetryBill/DetryBillView')

export default [
    {
        path:'/DetryBillIndex',
        name:'DetryBillComponent',
        component:DetryBillComponent
    }
]